(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
/* The arch video autoplays as decorative motion, so it must stop when the
   visitor asks for reduced motion — and gain controls so it stays playable. */
(function () {
  const apply = (section) => {
    const video = section.querySelector('.dbhero__arch-video');
    if (!video) return;
    const query = window.matchMedia('(prefers-reduced-motion: reduce)');
    const sync = () => {
      if (query.matches) {
        video.autoplay = false;
        video.pause();
        video.controls = true;
        video.setAttribute('data-motion-paused', '');
      } else {
        video.controls = false;
        video.removeAttribute('data-motion-paused');
        if (video.paused) video.play().catch(() => {});
      }
    };
    sync();
    query.addEventListener('change', sync);
  };
  document.querySelectorAll('.dbhero').forEach(apply);
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('.dbhero')) apply(e.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
class ProductRecommendations extends HTMLElement {
  connectedCallback() {
    if (this.loaded) return;
    const url = this.dataset.url;
    if (!url) return;
    const load = () => {
      this.loaded = true;
      fetch(url)
        .then((r) => (r.ok ? r.text() : Promise.reject(r.status)))
        .then((text) => {
          const fresh = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('product-recommendations');
          if (fresh && fresh.innerHTML.trim()) this.innerHTML = fresh.innerHTML;
        })
        .catch(() => {});
    };
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        if (entries.some((e) => e.isIntersecting)) { io.disconnect(); load(); }
      }, { rootMargin: '400px' });
      io.observe(this);
    } else {
      load();
    }
  }
}
if (!customElements.get('product-recommendations')) {
  customElements.define('product-recommendations', ProductRecommendations);
}

  } catch(e) { console.error(e); }
})();
})();
